import React, { useRef } from 'react';

import { Badge } from 'apps/auth/components/common/Badge/Badge';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { DiskBadge } from 'apps/auth/components/common/DiskBadge/DiskBadge';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { DiskBadgeWrapper, PanelContent, PanelFrame, PanelRightBlock, SelectedDiskBadge } from 'apps/auth/components/common/Panel/styles';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { PAYMENT_FLINKS } from 'apps/auth/constants/Constants';
import { URL_IMAGES_BANKS } from 'apps/auth/constants/UrlConstants';
import { usePageMessages } from 'apps/auth/hooks/selectors';

const DcFlink = ({ badge = '', actionBanner = '', ...props }) => {
    const popupRef = useRef(null);
    const { continueTransferFlow, changePaymentOption } = usePageMessages();
    const getBankIcon = (source) => {
        if (source.cardLogo) {
            return `${URL_IMAGES_BANKS}/${source.cardLogo}.png`;
        } else {
            return null;
        }
    };

    const getAltText = (source) => {
        if (source.cardLogo) {
            return source.cardLogo;
        } else {
            return null;
        }
    };

    const getIconName = (source) => {
        if (!source.cardLogo) {
            return 'card';
        } else {
            return null;
        }
    };

    const isActive = props.source.code === props.sourceCode;
    const alias = `${props.source.alias} ·· ${props.source.description}`;

    const onClickHandler = (e) => {
        if (actionBanner) {
            e.preventDefault();
            popupRef.current?.open(
                <SimplePopup text={<DangerouslyHtml dangerouslyHtml={actionBanner} popupRef={popupRef} />}>
                    <PopupButton
                        iconName="arrow-forward"
                        text={continueTransferFlow}
                        onClick={() => {
                            props.clickHandler?.(e, PAYMENT_FLINKS, props.source.code);
                            popupRef.current?.close();
                        }}
                    />
                    <PopupButton
                        iconName="retry"
                        text={changePaymentOption}
                        onClick={() => {
                            popupRef.current?.close();
                        }}
                    />
                </SimplePopup>,
            );
        } else {
            props.clickHandler?.(e, PAYMENT_FLINKS, props.source.code);
        }
    };

    return (
        <>
            <Panel onClick={onClickHandler} negativeMargin isHoverable>
                <PanelFrame>
                    <DiskBadgeWrapper>
                        <DiskBadge iconName={getIconName(props.source)} src={getBankIcon(props.source)} alt={getAltText(props.source)} />
                        {isActive && (
                            <SelectedDiskBadge>
                                <DiskBadge variant="selectedPassive" iconName="check" />
                            </SelectedDiskBadge>
                        )}
                    </DiskBadgeWrapper>
                    <PanelContent>{alias}</PanelContent>
                    <PanelRightBlock>{badge ? <Badge variant="primary" caption={badge} /> : null}</PanelRightBlock>
                </PanelFrame>
            </Panel>
            <PopupNew ref={popupRef} />
        </>
    );
};

export default DcFlink;
